<div class="card-cross text-right">
  <a
    href="javascript:void(0);"
    [attr.aria-label]="getAriaLabel() | adaFriendlyName: 'ariaLabel'"
    role="button"
    class="text-right"
    (click)="handleClick(pid)"
    (keyup.Enter)="handleClick(pid)"
  >
    <img
      [src]="imagePrefix+'/CRD/images/speedbump-close.jpg'"
      alt=""
      aria-hidden="true"
      role="presentation"
      width="10"
      height="10"
  /></a>
</div>
